import React, { Component, useEffect, useState } from 'react';
import { withCookies } from 'react-cookie';

import {toast} from "react-toastify";
import axios from '../../axios';
import {DOMAIN} from '../../constants';


function withErrorHandler( WrappedComponent ) {
    return (props)=> {

        const [errorText, seError] = useState(null)


             const reqInterceptor = axios.interceptors.request.use(req => {
                return req;
            });
            const resInterceptor = axios.interceptors.response.use(
                res => res,
                error => {
                console.log('error in axios.interceptors.response :', error.request, error.response.data.error);
                if (error.request.status === 403) {
                    // const { cookies } = this.props;
                    //
                    // cookies.remove('TOKEN', {path: '/'});
                    // window.location = DOMAIN ? DOMAIN : '/'
                }

                seError(errorText);

                if (error.request.status !== 404) {
                    // toast.error(error.message, {});
                }
                return Promise.reject(error);
            });
        
            useEffect(()=>{
                return ()=>{
                    axios.interceptors.request.eject(reqInterceptor);
                    axios.interceptors.response.eject(resInterceptor);
                }
            },[])

            return (
                <>
                    <WrappedComponent {...props} />
                </>
            );
    }
}



export default (WrappedComponent) => {
    return withCookies(withErrorHandler(WrappedComponent, axios));
};